// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1thVA","bigColWidth":"Table_bigColWidth__bFx27","biggerColWidth":"Table_biggerColWidth__3vNdn","row":"Table_row__3rocW","col":"Table_col__1wFc0"};